import { OrganisationIdAndNameOnly } from '@/types/organisation';
import { useUser } from './use-user';

export type UseUserOrganisationReturn = {
  organisation: OrganisationIdAndNameOnly | undefined;
};

export const useUserOrganisation = (): UseUserOrganisationReturn => {
  const { user } = useUser();
  const { organisation } = user;

  return {
    organisation: organisation
      ? {
          id: organisation.id,
          name: organisation.name,
        }
      : undefined,
  };
};
